// Under SSR, global.gon might not exist so we need to test for it
const taxonQuantityLimits = global.gon
  ? global.gon.taxonQuantityLimits || {}
  : {};

// Gets quantity limits by taxon from `global.gon` based on a taxon name
// if one does not exist, returns Infinity
export default function taxonQuantityLimit(taxonName) {
  return taxonQuantityLimits.hasOwnProperty(taxonName)
    ? taxonQuantityLimits[taxonName]
    : Infinity;
}
